export const DOMAIN_TYPES = {
  COLLEGE_PROFILE: 'CollegeProfile',
  COLLEGE_CONTENT: 'CollegeContent',
  COLLEGE_SESSION: 'CollegeSession',
  COLLEGE_SEARCH_CONTENT: 'CollegeAdvancedSearchContent',
  COLLEGE_CONTENT_SEARCH: 'CollegeContentSearch',
  COLLEGE_EVENT_SEARCH: 'CollegeEvents',
  COLLEGE_PROGRAM_SEARCH: 'CollegePrograms',
  COLLEGE_PREFERENCE_SEARCH_CONTENT: 'CollegePreferenceSearchContent',
  COLLEGE_COMPARE: 'CollegeCompare',
  COLLEGE_TILE: 'CollegeTile',
  IMPRESSION: 'Impression',
  STUDENT_DASHBOARD: 'StudentDashboard',
  DISCOVER: 'Discover',
  FOR_YOU: 'ForYou',
  PREFERENCES_SURVEY: 'PreferencesSurvey',
  GLOBAL_SEARCH: 'GlobalSearch',
  GLOBAL_SEARCH_RECENTS: 'GlobalSearchRecents',
  GLOBAL_SEARCH_YMAL: 'GlobalSearchYMAL',
  CAREER_ASSESSMENT: 'CareerAssessment',
  CAREER_OVERVIEW: 'CareerOverview',
  MESSAGE_CENTER: 'MessageCenter',
  SMART_SUGGESTIONS: 'SmartSuggestions',
  L1: 'L1',
  ADMISSION_INTELLIGENCE: 'AdmissionIntelligence',
  INTEREST_SHARING: 'InterestSharing',
  COLLEGE_SEARCH: 'CollegeSearch',
} as const

export const EVENT_TYPES = {
  ADVANCED_SEARCH: 'AdvancedSearch',
  COPY_PAGE_LINK: 'CopyPageLink',
  VIEW_PAGE: 'ViewPage',
  VIEW_PROFILE: 'ViewProfile',
  VIEW_CONTENT: 'ViewContent',
  VIEW_DISCOVER_COLLEGES: 'ViewDiscoverCollegesTab',
  VIEW_DISCOVER_POSTS: 'ViewDiscoverPostTab',
  VIEW_DISCOVER_EVENTS: 'ViewDiscoverEventsTab',
  VIEW_DISCOVER_PROGRAMS: 'ViewDiscoverProgramsTab',
  LINK_CLICK: 'LinkClick',
  MANAGE_COMPARE: 'ManageCompare',
  VIDEO_VIEW: 'VideoView',
  IMPRESSION: 'Impression',
  EXPAND: 'Expand',
  PREFERENCE_UPDATE: 'PreferenceUpdate',
  APPLY_WITH_SCOIR: 'ApplyWithScoir',
  START_PREFERENCES_SURVEY: 'StartPreferencesSurvey',
  COMPLETE_PREFERENCES_SURVEY: 'CompletePreferencesSurvey',
  PREDEFINED_SEARCH: 'PredefinedSearch',
  COLLEGE_CLICK: 'CollegeClick',
  NAME_SEARCH_CLICK: 'NameSearchClick',
  CONTENT_TAG_SEARCH_CLICK: 'ContentTagSearchClick',
  LINK_RESULT_CLICK: 'LinkResultClick',
  CAREER_CLICK: 'CareerClick',
  SHARE: 'Share',
  VIEW_ADMISSION_INTELLIGENCE: 'ViewAdmissionIntelligence',
  INTEREST_SHARING: 'InterestSharing',
} as const

export const EVENT_SOURCE_REFERRERS = {
  GLOBAL_HEADER: 'global-header',
  ADVANCED_SEARCH: 'advanced-search',
  PREFERENCE_SEARCH: 'preferences-search',
  COLLEGE_PROFILE: 'college-profile',
  COLLEGE_PROFILE_OVERVIEW: 'college-profile-overview',
  COLLEGE_PROFILE_ACADEMICS: 'college-profile-academics',
  COLLEGE_PROFILE_ADMISSIONS: 'college-profile-admissions',
  COLLEGE_PROFILE_STUDENT_LIFE: 'college-profile-student-life',
  COLLEGE_PROFILE_COST_AID: 'college-profile-cost-aid',
  COLLEGE_WALL: 'college-wall',
  COLLEGE_ANALYTICS: 'college-analytics',
  COLLEGE_SESSIONS: 'college-sessions',
  COLLEGE_COMPARE: 'college-compare',
  DASHBOARD: 'dashboard',
  DASHBOARD_SESSIONS: 'student-dashboard-sessions',
  MY_COLLEGES: 'my-colleges',
  COLLEGE_PROFILE_CONTENT: 'college-profile-content',
  COLLEGE_PROFILE_SESSIONS: 'college-profile-sessions',
  COLLEGE_CONTENT_SEARCH: 'college-content-search',
  COLLEGE_SEARCH_EVENTS: 'college-events',
  COLLEGE_SEARCH_PROGRAMS: 'college-programs',
  PREFERENCE_MATCH_INDICATOR: 'preference-match-indicator',
  MESSAGES: 'messages',
} as const

export const EVENT_CLICK_SOURCES = {
  PREDEFINED_SEARCH: 'PredefinedSearch',
  TYPE_AHEAD_SEARCH: 'TypeAheadSearch',
  NLP_COLLEGE_GLOBAL_SEARCH: 'NLPCollegeGlobalSearch',
  FOR_YOU_PREDEFINED_SEARCH: 'ForYouPredefinedCollegeList',
  FOR_YOU_TAGS: 'ForYouTagList',
  FOR_YOU_EVENTS: 'ForYouEventList',
  FOR_YOU_PROGRAMS: 'ForYouProgramList',
  ALL_TAGS: 'AllTagsModal',
  POST_TAG: 'PostTagList',
  CONTENT_TAG: 'ContentCardTag',
  CONTENT_CARD_CDP: 'ContentCardTagCDP',
  COLLEGE_TAB: 'CollegeTab',
  POSTS_TAB: 'PostsTab',
  EVENTS_TAB: 'EventsTab',
  PROGRAMS_TAB: 'ProgramsTab',
  L3_EVENTS_NAV: 'L3EventNav',
  L3_PROGRAMS_NAV: 'L3ProgramNav',
  L3_COLLEGE_NAV: 'L3CollegeNav',
  DASHBOARD: 'Dashboard',
  SAVED_SEARCH: 'SavedSearch',
  CAREERS: 'Careers',
} as const
